export const TRACE_DOWNLOAD_OMIT_LARGE_FIELDS_THRESHOLD = 350;
